export const useAuthPersistence = () => {
  const { refresh, loggedIn } = useAuth();

  // Handle visibility change
  const handleVisibilityChange = async () => {
    if (document.visibilityState === "visible" && !loggedIn.value) {
      try {
        console.log("Refreshing auth (line 8)");
        await refresh();
      } catch (error) {
        console.error("Auth refresh error:", error);
      }
    }
  };

  // Handle online status
  const handleOnline = async () => {
    if (!loggedIn.value) {
      try {
        console.log("Refreshing auth (line 11)");
        await refresh();
      } catch (error) {
        console.error("Auth refresh error:", error);
      }
    }
  };

  onMounted(() => {
    // Add event listeners
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("online", handleOnline);
  });

  onUnmounted(() => {
    // Remove event listeners
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    window.removeEventListener("online", handleOnline);
  });
};
